import { Component, Inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { Broadcast } from 'src/app/core/services/broadcast.service';
import { MatCardModule } from '@angular/material/card';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-delete-modal',
    imports: [MatDialogModule, MatButtonModule, MatIconModule, MatDividerModule, MatCardModule, DragDropModule],
    templateUrl: './delete-modal.component.html',
    styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly broadcast: Broadcast
  ) {}

  delete() {

    this.broadcast.broadcastEvent({
      event: 'deleteConfirmed',
      id: this.data.id
    });
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  }
}
